import { from as observableFrom, Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { NavigationService } from '../../../core/service/navigation.service';
import { Contract } from '../../model/contract';
import { MessageService } from '../../../core/service/message.service';
import { CooperativeHousingContract } from '../../model/cooperative-housing-contract';

@Injectable()
export class TransferCooperativeHousingCommandHandler implements ICommandHandler {
  constructor(
    private _navigationService: NavigationService,
    private _messageService: MessageService
  ) {}

  canExecute(command: Command): boolean {
    if (command instanceof Command && command.context instanceof CooperativeHousingContract) {
      return (
        command.id === leaseAgreementCommand.transferCooperativeHousing &&
        (!command.context.lastBillingDate || !command.context.lastBillingDate.hasValue())
      );
    }
    return false;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof Command) {
      return observableFrom(this._navigationService.navigateChild([command.context.id, 'transfer']));
    }
  }
}
